
// display map modal or popover on click
//

jQuery(window).on('load', function(){

	var $map = $('#js-map');

	if (!$map.length) return;

	var countriesInfo = modalObject.countriesInfo;

	Object.keys(countriesInfo).forEach(function(key) {

		var selector = jQuery('.'+key);
		var color = countriesInfo[key]['color'];
		var name = countriesInfo[key]['name'];
		var preffix = countriesInfo[key]['preffix'];
		selector.css("fill" ,color );
		selector.data("land", name );
		selector.data("preffix", preffix );
		
	});

	jQuery('.land').on("click", function() {
    // modalObject is set by localize script
    var land = '';
    var landUrl = '';
    var domain = modalObject.domain;
    var textTrue = modalObject.textTrue;
		var textFalse = modalObject.textFalse;

    // get land name from data attribute
		var land = jQuery(this).data("land");
		var preffix = jQuery(this).data("preffix");
    // compose link url from it
    var landUrl = 'https://'+preffix+'.'+domain;

    // remove style of previously selected land
    jQuery('.active').removeClass('active');
    // and add the style
    jQuery(this).addClass('active');

    // if land is not available
    if (land) {
		jQuery('#modal').modal('show');
		jQuery("#land-url").attr("href",landUrl);
		jQuery(".land-links").html(land);
		jQuery("#land").html(land);
		jQuery("#land-title").html('Viasat Connect '+land);
		jQuery("#text-true").html(textTrue);
    }
    // display popover instead
    else {
		jQuery("[data-toggle=popover]").popover({
        html: true,
      	content: textFalse
      });
    }

  });


	var tooltipSelector = '#map-tooltip';
	
	var showCountryName = function(e) {
		var countriesInfo = modalObject.countriesInfo;
		var $land = jQuery(e.target),
			 id = $land.attr('id'),
			 offset = $land.offset(),
			 borderBox = e.target.getBBox(),
			 h = borderBox.height,
			 w = borderBox.width,
			 countryName = countriesInfo[id]['name'],
			 $nameContainer = jQuery('<div class="tooltip-available" id="' + tooltipSelector.substr(1) + '"></div>')
			;
			console.log(countriesInfo[id]);
			console.log(e);

		if (countryName) {
			$nameContainer
				.css('top', $land[0].getBoundingClientRect().top + h/2)
				.css('left', $land[0].getBoundingClientRect().left + w/2)
				.text(countryName)
				;
			$('body').append($nameContainer);

		}
	};
	var hideCountryName = function(e) {
		var $nameContainer = jQuery(tooltipSelector);
		if ($nameContainer && $nameContainer.length) $nameContainer.remove();
	};
	jQuery('body')
	.on('mouseenter', 'path.land', showCountryName)
	.on('mouseleave', 'path.land', hideCountryName)
	;
});